import React from 'react'
import Top from '../components/top'
import About from '../components/about'
import News from '../components/news'





function Home(props){

  const homeStyle = {

  }

  return(
    <div>
      <Top />
      <div style={homeStyle}>
        <About />
        <hr/>
        <News />
      </div>
      
    </div>
    
  )
}






export default Home